module.exports = __webpack_public_path__ + "static/media/BovExo_template_import_birth.a72177a0.xlsx";